// src/pages/hr/HRAssets.jsx
import AdminAssets from "../admin/AdminAssets";

export default AdminAssets;
